export default __webpack_public_path__ + "static/media/setting_4.c3480bc5.png";